<template>
    <dropdown-confirmation
            name="saveReport"
            size="lg"
            direction="right"
            triggerBtnClass="btn-light"
            triggerBtnHtml='<i class="fa fa-save"></i>&nbsp;&nbsp;Save Report'
            confirmBtnClass="btn-success"
            confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;Save'
            @confirm="saveReport"
    >
        <slot>
            <div class="row">
                <div class="col">
                    <p><strong>SAVE REPORT</strong><br /><br />
                        Give this report a name in order to re-run or reference it later. Saved reports are visible on the dashboard.</p>
                </div>
            </div>

            <div class="row lined">
                <div class="col-4 col-form-label">Name</div>
                <div class="col-8">
                    <input type="text" class="form-control" v-model="name">
                </div>
            </div>
        </slot>
    </dropdown-confirmation>

</template>

<script type="text/babel">
    import DropdownConfirmation from './DropdownConfirmation.vue';

    export default {
        name: "SaveReport",
        data: function(){
            return {
                name: ''
            }
        },
        components:{
            DropdownConfirmation
        },
        methods:{
            saveReport(){

                this.$send(this, 'userReportCreate',{
                    name: this.name,
                    reportString: this.$route.fullPath
                }).then(r => {
                    this.$store.commit('setStatus', {
                        status: true,
                        message: "Report saved!"
                    });
                });

                /*
                this.$http.post('http://10.0.24.14/api.php', {
                    function: 'userReportCreate',
                    data:{
                        name: this.name,
                        reportString: this.$route.fullPath
                    }
                }, {
                    emulateJSON: true
                }).then(function(response){
                    if(response.body.status){
                        this.$store.commit('setStatus', {
                            status: true,
                            message: "Report saved!"
                        });
                    } else {
                        this.$store.commit('setStatus', {
                            status: false,
                            message:response.body.message
                        });
                    }
                });
                */
            },
        }

    }
</script>


// WEBPACK FOOTER //
// SaveReport.vue?eb048916